export interface AppConfig {
  api: {
    baseUrl: string;
  };
  app: {
    name: string;
    version: string;
  };
  urls: {
    /** Marketing / landing site (landing-v2). e.g. https://stoxly.ai */
    landing: string;
    /** Web app (apps/web) users register on. e.g. https://app.stoxly.ai */
    webApp: string;
  };
}

/** Trim a single trailing slash so links compose cleanly with `/?f=`. */
function trimTrailingSlash(url: string): string {
  return url.replace(/\/$/, '');
}

class ConfigService {
  private config: AppConfig;

  constructor() {
    this.config = {
      api: {
        baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
      },
      app: {
        name: import.meta.env.VITE_APP_NAME || 'Stoxly Admin',
        version: import.meta.env.VITE_APP_VERSION || '1.0.0',
      },
      urls: {
        landing: trimTrailingSlash(import.meta.env.VITE_LANDING_URL || 'http://localhost:4321'),
        webApp: trimTrailingSlash(import.meta.env.VITE_WEB_APP_URL || 'http://localhost:5173'),
      },
    };
  }

  get(): AppConfig {
    return this.config;
  }

  getApiUrl(): string {
    return this.config.api.baseUrl;
  }

  getLandingUrl(): string {
    return this.config.urls.landing;
  }

  getWebAppUrl(): string {
    return this.config.urls.webApp;
  }

  /**
   * The campaign tracking link for a code: the landing root with `?f=<code>`. The landing's
   * cookie banner asks for marketing consent and writes the shared `stoxly_ref` cookie only
   * then (owner ruling R111, 2026-10-12). FAILURE IT PREVENTS: the admin also handed out an
   * app link (`/register?f=`); the app has no banner, so under R111 it writes nothing and such
   * a link would credit no sign-up while looking like a tracking link.
   */
  campaignLinks(code: string): { landing: string } {
    return { landing: `${this.config.urls.landing}/?f=${code}` };
  }
}

export const configService = new ConfigService();
export default configService;
